module.exports = __webpack_public_path__ + "img/avatar1.fc4ce1cd.png";